import { type RestoreNodesFn, type TrashNodesFn } from '@/types/trash';
import type { Command } from '@/context/CommandContext';
import { type DuplicateAssetFn } from '@/types/asset';
import { DAMNodeType } from '@/types/tree';
import { t } from '@/i18n/translator';

export const DuplicateAssetCommand = (
  assetId: string,
  destinationFolderId: string,
  name: string,
  duplicateAssetMutation: DuplicateAssetFn,
  trashNodesMutation: TrashNodesFn,
  restoreNodesMutation: RestoreNodesFn,
): Command => {
  let duplicateId = '';

  const apply = () => duplicateAssetMutation({ id: assetId, destinationFolderId });

  const update = (params: { id: string }) => {
    duplicateId = params.id;
  };

  const undo = (): void => {
    void trashNodesMutation({ nodes: [duplicateId], type: DAMNodeType.Asset });
  };

  const redo = (): void => {
    void restoreNodesMutation({ nodes: [duplicateId], type: DAMNodeType.Asset });
  };

  return {
    apply,
    update,
    undo,
    redo,
    message: t('commands.duplicateAsset', { name }),
  };
};
